import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { userProfileAPIUrls } from '../data';

type Response = {
  success: boolean;
  message: string;
};
export const saveImage = withLogger(async (payload): Promise<Response> => {
  const url = userProfileAPIUrls.image.store;

  // Check if the payload is FormData
  const headers = { 'Content-Type': 'multipart/form-data' };

  const { data } = await authServiceAxiosClient.post<Response>(url, payload, {
    headers,
  });

  return data;
});
